import React, { PropsWithChildren, ReactNode } from 'react';
import cx from 'classnames';

import SesamLink from '../common/Links/SesamLink';

import { useTheme } from '@material-ui/core';

import { useSelector } from 'react-redux';
import { RootState } from 'src/types/state.types';

import './MenuLinkAction.scss';

export const MenuLinkAction: React.FC<
  PropsWithChildren<{
    disabled?: boolean;
    label: ReactNode;
    to: string;
    role?: string;
    linkClassName?: string;
    title?: string;
    tabIndex?: number;
  }>
> = ({ children, disabled, label, to, role, linkClassName, title, tabIndex, ...props }) => {
  const theme = useTheme();
  const isDark = useSelector((state: RootState) => state.theme.dark);

  return (
    <li className="menu__item" style={{ color: theme.palette.text.primary }} {...props}>
      {children}
      {disabled ? (
        <span
          className="menu-link-action"
          style={{ color: theme?.palette.action.disabled }}
          title={title}
          role={role}
        >
          {label}
          {children}
        </span>
      ) : (
        <SesamLink
          className={cx('menu-link-action', isDark ? 'dark' : 'light', linkClassName)}
          to={to}
          title={title}
          buttonLink={true}
          tabIndex={tabIndex}
          role={role}
        >
          {label}
          {children}
        </SesamLink>
      )}
    </li>
  );
};
